import React from 'react';
import { SourceModel, sourceModelInitial } from '../../../Models/SourceModel';

export interface IClientSourceContextProps {
    actionFieldIndex: number
    setActionFieldIndex: (value: number) => void    
    isInEditMode: boolean
    setIsInEditMode: (value: boolean) => void    
    currentSource: SourceModel
    setCurrentSource: (source: SourceModel) => void    
}

export const ClientSourceContextInitial: IClientSourceContextProps = {
    actionFieldIndex: -1,
    setActionFieldIndex: () => { ''; },
    isInEditMode: false,
    setIsInEditMode: () => { ''; },
    currentSource: sourceModelInitial,
    setCurrentSource: () => { ''; },
};

export const ClientSourceContext = React.createContext(ClientSourceContextInitial);